import { useState } from "react";
import { SECTIONS } from "../../../mocks/clueSite";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="bg-background-50 border-b border-background-200/70">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded bg-primary-600 text-background-50">
              <i className="ri-error-warning-fill text-lg" />
            </span>
            <span className="leading-none">
              <span className="block font-heading text-xl md:text-2xl font-black tracking-wide text-foreground-950">
                51<span className="text-primary-600">黑料</span>
              </span>
              <span className="block mt-0.5 text-[10px] md:text-[11px] tracking-[0.2em] text-foreground-500">
                线 索 · 密 报 · 线 人
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {SECTIONS.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                className="rounded-md px-3 py-2 text-sm text-foreground-600 hover:bg-background-100 hover:text-primary-700 whitespace-nowrap"
              >
                {s.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#rank"
              className="hidden md:inline-flex items-center gap-1.5 rounded-full border border-secondary-300 px-3.5 py-1.5 text-sm text-foreground-700 hover:border-accent-500 hover:text-accent-700 whitespace-nowrap"
            >
              <i className="ri-fire-line" />
              热度榜
            </a>
            <a
              href="#guide"
              className="inline-flex items-center gap-1.5 rounded-full bg-primary-600 px-4 py-1.5 text-sm text-background-50 hover:bg-primary-500 whitespace-nowrap"
            >
              <i className="ri-upload-2-line" />
              投稿爆料
            </a>
            <button
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden inline-flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700"
              aria-label="菜单"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-2-line text-lg"} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2">
            {SECTIONS.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                onClick={() => setOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              >
                {s.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}